import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../components/custom_components/BackgroundBox'
import { NewLoadingAndErrors } from '../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'
import { useAuth } from '../../context/auth-context'
import { useMeetingRequestByReviewer } from '../../graphql/meeting/hooks/useMeetingRequestByReviewer'
import { MeetingViewInfoBox } from './infoBox/MeetingViewInfoBox'
import { RequestedMeetingsTable } from './RequestedMeetingsTable'

export const RequestedMeetingsContainer = (): JSX.Element => {
  const { user } = useAuth()
  const { t } = useTranslation()
  const { data, error, loading } = useMeetingRequestByReviewer(user.employeeId)

  if (loading || error || !data || !data.getMeetingRequestsByReviewer) {
    return (
      <BackgroundBox r height="withTabs">
        <NewLoadingAndErrors isLoading={loading} hasNoData={!data} error={error} showSpinner t={t} />
      </BackgroundBox>
    )
  }

  return (
    <>
      <MeetingViewInfoBox data={data.getMeetingRequestsByReviewer} isRequestedMeetings />
      <RequestedMeetingsTable requestedMeetings={data.getMeetingRequestsByReviewer} />
    </>
  )
}
